import React from "react";

import { ExecutionPanelHeader } from "./header/ExecutionPanelHeader";

import { ExecutionPanelChat } from "./ExecutionPanelChat";
import { useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useExecutionPanelContext } from "@src/features/ai/components/WorkflowEditor/execution/panel/ExecutionPanelContext";
import { SxProps, Theme } from "@mui/material/styles";
import { mergeSx } from "@intelligems/ig-theme";

interface ExecutionPanelBodyProps {
  sx?: SxProps<Theme>;
}

export const ExecutionPanelBody = ({ sx }: ExecutionPanelBodyProps) => {
  const theme = useTheme();
  const { ref, getSlot, layoutDensity } = useExecutionPanelContext();

  return (
    <Grid
      ref={ref}
      container
      data-layout-density={layoutDensity ?? "default"}
      direction={"column"}
      flexWrap={"nowrap"}
      className="ai-elements-container"
      sx={mergeSx(
        {
          height: "100%",
          backgroundColor: theme.igBackgroundColors.baseLightLow,
          display: "flex",
        },
        sx
      )}
    >
      {getSlot("header", <ExecutionPanelHeader />)}
      {getSlot("body", <ExecutionPanelChat />)}
    </Grid>
  );
};
